export var DEFAULT_FS_BOOLEAN_FLAG_VALUE = true;
export var BOOLEAN_FLAG;
(function (BOOLEAN_FLAG) {
    BOOLEAN_FLAG["NEW_ACL_API_1"] = "new_acl_api_1";
})(BOOLEAN_FLAG || (BOOLEAN_FLAG = {}));
